import { useState, useCallback } from 'react'
import { redirectToMiniProgram } from '@/utils/wx'
import { useFetcher, type ApiResponse } from '../common/useFetcher'
import { useMountEffect } from '../common/useMountEffect'

type WxLoginParams =
  | { type: 'unionid'; unionid: string }
  | { type: 'phone'; openid: string; code: string }

type WxLoginStatus = 'idle' | 'loading' | 'success' | 'error'

export const parseWxLoginParams = (): WxLoginParams | null => {
  const params = new URLSearchParams(window.location.search)
  const unionid = params.get('wxunionid')
  const openid = params.get('wxopenid')
  const code = params.get('wxcode')

  if (unionid) return { type: 'unionid', unionid }
  if (openid && code) return { type: 'phone', openid, code }
  return null
}

const cleanWxLoginParams = () => {
  const url = new URL(window.location.href)
  url.searchParams.delete('wxunionid')
  url.searchParams.delete('wxopenid')
  url.searchParams.delete('wxcode')
  window.history.replaceState({}, '', url.toString())
}

export const useWxLogin = () => {
  const fetcher = useFetcher()
  const [status, setStatus] = useState<WxLoginStatus>('idle')

  const login = useCallback(async () => {
    const params = parseWxLoginParams()
    if (!params) return

    setStatus('loading')
    try {
      const response = await fetcher(
        params.type === 'unionid'
          ? ['wxlogin', { unionid: params.unionid }]
          : ['wxphonelogin', { openid: params.openid, code: params.code }]
      ) as ApiResponse

      if (response.status === 0) {
        cleanWxLoginParams()
        setStatus('success')
        window.location.reload()
        return
      }

      console.warn('微信登录失败:', response.msg, response)
      setStatus('error')
      redirectToMiniProgram('/pages/login/login')
    } catch (error) {
      console.error('微信登录失败', error)
      setStatus('error')
      redirectToMiniProgram('/pages/login/login')
    }
  }, [fetcher])

  useMountEffect(() => {
    if (parseWxLoginParams()) {
      void login()
    }
  })

  return { status, login }
}
